import React from "react"
import {ContentLayout} from "../layouts/ContentLayout";
import EditAppSettingsFormContainer from "../components/containers/AppSettingsFormContainer";

export function Settings() {
    return (
        <ContentLayout title="Настройки">
            <div className="row">
                <EditAppSettingsFormContainer />
            </div>
        </ContentLayout>
    );
}